import { AfterViewInit, Component, ElementRef } from '@angular/core';
import { ListEventService } from '../list-item/list-event.service';

@Component({
  selector: 'ui-list-option',
  templateUrl: './list-option.component.html'
})
export class ListOptionComponent implements AfterViewInit {
  constructor(private listEventService: ListEventService,
              private elementRef: ElementRef) {
  }

  ngAfterViewInit() {
    // åå¸å½åç»ä»¶ç dom åç´ ï¼ä»¥ä¾¿è®© list-sliding ç»ä»¶å¨åå¨æ¶ï¼è®¡ç®æå¤§åå¨å®½åº¦
    this.listEventService.addOption(this.elementRef);
  }
}